/*------------------------------------------------
// File Name:PDM_CONFIG_VALUES.js
// File Description:PDM_CONFIG_VALUES store方法
// Author:zxl
// Create Time:2022/08/22 12:20:52
//------------------------------------------------*/

import {
    GetPDM_CONFIG_VALUESList,
    GetPDM_CONFIG_VALUESListByPage,
    GetPDM_CONFIG_VALUESEntity,
    CreatePDM_CONFIG_VALUESEntity,
    UpdatePDM_CONFIG_VALUESEntity,
    DeletePDM_CONFIG_VALUESEntity,
} from '@/api/pdm/configValues'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmConfigValues = {
    namespaced: true,
    state: {
        PdmConfigValuesList: [],
        PdmConfigValuesListLoading: false,
        PdmConfigValuesEntity: null,
        PdmConfigValuesShowDlg: false,
        PdmConfigValuesShowDlg2: false,
        ImgShowDlg: false,
    },
    mutations: {
        setPdmConfigValuesList(state, dataList) {
            state.PdmConfigValuesList = [...dataList]
        },
        setPdmConfigValuesListLoading(state, visible) {
            state.PdmConfigValuesListLoading = visible
        },
        setPdmConfigValuesShowDlg(state, visible) {
            state.PdmConfigValuesShowDlg = visible
        },
        setPdmConfigValuesShowDlg2(state, visible) {
            state.PdmConfigValuesShowDlg2 = visible
        },
        setImgShowDlg(state, visible) {
            state.ImgShowDlg = visible
        },
        setPdmConfigValuesEntity(state, entity) {
            state.PdmConfigValuesEntity = entity
        },
    },
    actions: {
        //创建对象
        actCreatePdmConfigValues({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_CONFIG_VALUESEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmConfigValuesEntity', res.Data)
                        commit('setPdmConfigValuesShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载对象
        actGetPdmConfigValuesEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmConfigValuesListLoading', true)
                GetPDM_CONFIG_VALUESEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmConfigValuesList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmConfigValuesListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载列表
        actGetPdmConfigValuesList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmConfigValuesListLoading', true)
                GetPDM_CONFIG_VALUESList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmConfigValuesList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmConfigValuesListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载列表
        actGetPdmConfigValuesListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmConfigValuesListLoading', true)
                GetPDM_CONFIG_VALUESListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmConfigValuesList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmConfigValuesListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存信息
        actUpdatePdmConfigValues({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_CONFIG_VALUESEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmConfigValuesShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_CONFIG_VALUES
        actEditPdmConfigValuesData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmConfigValuesID : entity.PdmConfigValuesID
                }
                GetPDM_CONFIG_VALUESEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmConfigValuesEntity', res.Data)
                        commit('setPdmConfigValuesShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_CONFIG_VALUES ,传对象过来
        actEditPdmConfigValues({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmConfigValuesEntity', entity)
                commit('setPdmConfigValuesShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_CONFIG_VALUES
        actDeletePdmConfigValues({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前？").onOk(() => {
                    DeletePDM_CONFIG_VALUESEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmConfigValuesShowDlg', false)
                           
                            msg.success("删除成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除失败，原因:" + res.Message)
                            //msg.success("删除失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


